import { FC } from "react";
import { Box, Divider, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import formatDayLabel from "src/utils/Company/Absences/formatDayLabel";

interface IBalanceStatusBadgeProps {
  labelUT: string;
  days?: number;
  hours?: number;
  overdueDays?: number;
  overdueHours?: number;
  color: string;
}

const BalanceStatusBadge: FC<IBalanceStatusBadgeProps> = ({
  labelUT,
  days,
  hours,
  overdueDays,
  overdueHours,
  color,
}) => {
  const noLimit = days === undefined && hours === undefined;

  return (
    <Box
      sx={{
        background: "white",
        padding: "0.5rem 1rem",
        borderRadius: "0.25rem",
        inlineSize: "fit-content",
      }}
      data-testId="absence-balance-status"
    >
      <Typography variant="subtitle2" component="span">
        {__(labelUT)}:{" "}
      </Typography>
      <Typography
        variant="subtitle2"
        color={color}
        component="span"
        data-testId="absence-balance-status__count"
      >
        {noLimit
          ? __("brak limitu")
          : `${days} ${__(formatDayLabel(days!))} / ${hours}h`}
      </Typography>
      {overdueDays || overdueHours ? (
        <>
          <Divider sx={{ m: "0.5rem 0 0" }} />
          <Typography variant="caption">{__("W tym zaległe")}:</Typography>
          <Typography variant="subtitle2" color="info.dark">
            {`${overdueDays} ${__(
              formatDayLabel(overdueDays!)
            )} / ${overdueHours}h`}
          </Typography>
        </>
      ) : null}
    </Box>
  );
};

export default BalanceStatusBadge;
